import {
  formatLocalizedDateMonth,
  shortDayNameFormatter,
  timeFormatter
} from '@hconnect/uikit/src/common/utils/dateformatting'
import type {Moment} from 'moment-timezone'

/**
 * function to return localized date time, example: "ddd DD/MM, HH:mm"
 * (short day name, day of month, hours and minutes)
 */
export const getLocalizedDayMonthTimeFormat = (
  datetime: Moment,
  timezoneId: string,
  locale: string
): string => {
  const timezoneOffset = datetime.tz(timezoneId).utcOffset()

  const shortDayName = shortDayNameFormatter(datetime, locale, timezoneOffset)
  const dateMonth = formatLocalizedDateMonth(datetime, locale)
  const time = timeFormatter(datetime, locale, timezoneOffset)
  return `${shortDayName} ${dateMonth}, ${time}`
}
